<div style="display: block;" [ngStyle]="{ 'background-color': mergedOptions.layout.backgroundColor }">
  <canvas baseChart
    [datasets]="datasets"
    [labels]="labels"
    [options]="mergedOptions"
    [chartType]="type"
    [plugins]="plugins">
  </canvas>
</div>
